module.exports = __webpack_public_path__ + "assets/img/img60.17b6408a.png";